<template>
    <div class="ModalFooter">
      <button-cta v-if="!hideCancelText" theme="secondary" :onClick="closeModal">
        {{ cancelText }}
      </button-cta>
      <button-cta v-if="!hideConfirmText" :class="`btn-${confirmTheme}`" :onClick="confirm" :disabled="confirmDisabled">
        {{ confirmText }}
      </button-cta>
    </div>
</template>

<script>
import ButtonCta from '@/components/Button/button'

export default {
  name: 'ModalFooter',
  components: {
    ButtonCta
  },
  props: {
    closeModal: Function,
    confirm: Function,
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    confirmDisabled: Boolean,
    confirmText: {
      type: String,
      default: 'Save'
    },
    confirmTheme: {
      type: String,
      default: 'primary'
    },
    hideCancelText: Boolean,
    hideConfirmText: Boolean
  }
}
</script>

<style lang="scss">
    .ModalFooter {
      padding: 15px;
      text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/Modal/modal-footer.vue